/**
 * MockupGridItem — single mockup preview in editor grid.
 * Replaces window.MockupGridItem.
 */
import type { FC } from 'react';
import { MockupCanvas } from './Canvas';
import type { Product } from '../stores/appStore';
import type { Transform } from '../stores/types';

interface Props {
  product: Product;
  imageUrl: string;
  transform: Transform;
  onUpdateTransform: (t: Transform) => void;
  isActive: boolean;
  onActivate: () => void;
  activeTab: string;
  maskColor: string | null;
}

export const MockupGridItem: FC<Props> = ({
  product,
  imageUrl,
  transform,
  onUpdateTransform,
  isActive,
  onActivate,
  activeTab,
  maskColor,
}) => {
  const maskUrl = activeTab === 'products' ? product.mask : product.mockupMask || product.mask;
  const overlayUrl =
    activeTab === 'products' ? product.overlay : product.mockupOverlay || product.overlay;

  return (
    <div className="mockup-grid-item group relative">
      <MockupCanvas
        product={product}
        imageUrl={imageUrl}
        maskUrl={maskUrl}
        overlayUrl={overlayUrl}
        transform={transform}
        onUpdateTransform={onUpdateTransform}
        productId={product.id}
        dpi={product.dpi || 300}
        isActive={isActive}
        onActivate={onActivate}
        maskColor={maskColor}
      />
      <div className="absolute bottom-1 left-0 right-0 text-center">
        <span className="text-[10px] text-slate-400 font-medium bg-slate-900/80 px-2 py-0.5 rounded backdrop-blur">
          {product.name}
        </span>
      </div>
    </div>
  );
};
